var _circle, _path, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyStateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 32,
    fill: "#EBF6F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 61.0002C44.6732 61.0002 59 46.6733 59 29.0002C59 20.3287 55.5509 12.4629 49.9498 6.69971C60.0908 12.0678 67 22.7271 67 35.0002C67 52.6733 52.6732 67.0002 35 67.0002C25.9983 67.0002 17.8648 63.2833 12.0503 57.3006C16.5123 59.6626 21.6 61.0002 27 61.0002Z",
    fill: "#EBF6F7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 25,
    r: 3.5,
    stroke: "url(#paint0_linear_4086_34500)",
    strokeOpacity: 0.48
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 49,
    r: 2.5,
    stroke: "url(#paint1_linear_4086_34500)",
    strokeOpacity: 0.48
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 40,
    r: 2.5,
    stroke: "url(#paint2_linear_4086_34500)",
    strokeOpacity: 0.48
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 11,
    r: 2.5,
    stroke: "url(#paint3_linear_4086_34500)",
    strokeOpacity: 0.48
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 34,
    r: 2.5,
    stroke: "url(#paint4_linear_4086_34500)",
    strokeOpacity: 0.48
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 25.5,
    r: 5,
    stroke: "url(#paint5_linear_4086_34500)",
    strokeOpacity: 0.48
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 50.5,
    r: 6,
    stroke: "url(#paint6_linear_4086_34500)",
    strokeOpacity: 0.48
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4086_34500",
    x1: 48,
    y1: 21,
    x2: 48,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFC2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCF3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4086_34500",
    x1: 17,
    y1: 46,
    x2: 17,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFC2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCF3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4086_34500",
    x1: 57,
    y1: 37,
    x2: 57,
    y2: 43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFC2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCF3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4086_34500",
    x1: 36,
    y1: 8,
    x2: 36,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFC2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCF3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4086_34500",
    x1: 35,
    y1: 31,
    x2: 35,
    y2: 37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFC2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCF3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4086_34500",
    x1: 18.5,
    y1: 20,
    x2: 18.5,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFC2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCF3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4086_34500",
    x1: 44.5,
    y1: 44,
    x2: 44.5,
    y2: 57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFC2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCF3FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateIcon);
export default __webpack_public_path__ + "static/media/empty_state_icon.a42d69a63a3be5f70be0e9d25a691855.svg";
export { ForwardRef as ReactComponent };